import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { makeStyles } from "tss-react/mui";
import { Table, TableRow, TableHead, TableContainer, Box, Grid, } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Assets from "../../Components/Common/ImageContainer";
import PaperContainer from "../../Components/Common/PaperContainer";
import TableHeading from "../../Components/Common/CommonTableHeading";
import CommonModal from "../../Components/Common/CommonModel";
import { useAppContext } from "../../Context/context";
import axios from "../../APiSetUp/axios";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";
import AddBranch from "../../Components/Designation";
import DataNotFound from "../../Components/Common/DataNotFound";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { lightTheme } from "../../theme";
import { permissionStatus } from "../../Utils/enum";
import { Regex } from "../../Utils/regex";
import WidgetLoader from "../../Components/Common/widgetLoader";
import Swal from "sweetalert2";
import CustomPagination from "../../Components/Common/CustomPagination";
import AddDesignation from "../../Components/Designation";
import AddSiteType from "../../Components/SitePopularity";
import AddSitePopularity from "../../Components/SitePopularity";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: 600,
    fontSize: 14,
    color: theme.palette.primary.main,
    fontFamily: "Poppins",
    padding: 5,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: 500,
    padding: "8px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const useStyles = makeStyles()((theme) => {
  return {
    paddedRow: {
      padding: "15px 10px",
    },
    writeBox: {
      borderRadius: "6px",
      padding: "8px",
      backgroundColor: lightTheme.palette.bgLightExtraPrimary.main,
      color: lightTheme.palette.primary.main,
      cursor: "pointer",
    },
    viewBox: {
      borderRadius: "6px",
      padding: "8px",
      color: lightTheme.palette.bgLightSuccess.main,
      backgroundColor: lightTheme.palette.bgLightExtraSuccess.main,
      cursor: "pointer",
    },
    deleteBox: {
      borderRadius: "6px",
      padding: "8px",
      color: lightTheme.palette.bgLightRed.main,
      backgroundColor: lightTheme.palette.bgLightExtraRed.main,
      cursor: "pointer",
    },
  };
});

const SitePopularity = () => {
  const { classes } = useStyles();
  const location = useLocation();
  const { pathname } = location;

  const { OnUpdateError, toggleLoader, menuList } = useAppContext();

  //States
  const [model, setModel] = useState(false);
  const [data, setData] = useState({});
  const [error, setError] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [sitePopularityDetails, setSitePopularityDetails] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [permissions, setPermissions] = useState({});
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false)

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  //Validation
  const handleValidation = () => {
    let formIsValid = true;
    let errors = {};
    if (!data?.sitePopularity) {
      formIsValid = false;
      errors["sitePopularity"] = "Please enter site popularity";
    }
    setError(errors);
    return formIsValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("name, value ", name, value)
    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const _getSitePopularity = () => {
    setLoading(true)
    let body = {
      limit: rowsPerPage,
      page: page,
      search: search || ""
    };
    axios.post(`/sitePopularity`, body)
      .then((res) => {
        if (res?.data?.data) {
          setSitePopularityDetails(res?.data?.data);
        }
      })
      .catch((err) => {
        OnUpdateError(err.data.message);
      }).finally(() => setLoading(false));
  };

  const handleClear = () => {
    setModel(false);
    setData({});
    setError({});
    setIsEdit(false);
  };

  const _addUpdateSitePopularity = () => {
    if (handleValidation()) {
      toggleLoader();
      let body = {
        sitePopularity: data?.sitePopularity,
      };
      if (data?.description) {
        body.description = data?.description
      }
      if (data?._id) {
        body.id = data?._id;
      }
      axios
        .post(`sitePopularity/${data?._id ? "update" : "create"}`, body)
        .then((res) => {
          if (res?.data?.data) {
            swal("Success", res?.data?.message, "success");
            handleClear();
            _getSitePopularity();
          }
          toggleLoader();
        })
        .catch((err) => {
          toggleLoader();
          OnUpdateError(err.data.message);
        });
    }
  };

  const _handleDelete = (deleteId) => {
    Swal.fire({
      title: "<strong>Warning</strong>",
      icon: "error",
      html: "Are you sure you want to delete site popularity",
      showCancelButton: true,
      confirmButtonColor: "#0492c2",
      iconColor: "#ff0000",
      confirmButtonText: "Yes",
      cancelButtonColor: "#1A1B2F",
    }).then(async (result) => {
      if (result.isConfirmed) {
        toggleLoader();
        axios
          .delete(`/sitePopularity/delete/${deleteId}`)
          .then((res) => {
            swal("Success", res?.data?.message, "success");
            toggleLoader();
            _getSitePopularity();
          })
          .catch((err) => {
            toggleLoader();
            OnUpdateError(err.data.message);
          });
      }
    });
  };

  useEffect(() => {
    _getSitePopularity();
  }, [page, rowsPerPage, search]);

  useEffect(() => {
    const menu = menuList?.find((e) => e?.path === pathname);
    if (menu) {
      const menuPermissions = menu.permissions;
      setPermissions({
        view: menuPermissions.includes(permissionStatus.view) ? true : false,
        create: menuPermissions.includes(permissionStatus.create) ? true : false,
        update: menuPermissions.includes(permissionStatus.update) ? true : false,
        delete: menuPermissions.includes(permissionStatus.delete) ? true : false,
      });
    }
  }, [menuList, location]);

  return (
    <>
      <PaperContainer elevation={0} square={false}>
        <Grid container>
          <Grid item xs={12}>
            <TableHeading
              title="Site Popularity List"
              buttonText={permissions?.create ? `Add Site Popularity` : ""}
              onClick={() => setModel(true)}
              handleSearch={(value) => { setPage(1); setSearch(value); }}
            />
          </Grid>
          <Grid item xs={12}>
            <TableContainer>
              {!loading ? (
                <Table sx={{ minWidth: 600 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell className={classes.paddedRow}>No.</StyledTableCell>
                      <StyledTableCell>Site popularity</StyledTableCell>
                      <StyledTableCell>Site popularity description</StyledTableCell>
                      <StyledTableCell align="center" >Action</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sitePopularityDetails?.response?.length > 0 ? sitePopularityDetails?.response?.map((row, index) => {
                      return (
                        <StyledTableRow key={index}>
                          <StyledTableCell className={classes.paddedRow}>
                            {(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {row.sitePopularity}
                          </StyledTableCell>
                          <StyledTableCell>{row.description ? row.description : "-"}</StyledTableCell>
                          <StyledTableCell>
                            <Box display={"flex"} gap={1} justifyContent={"center"}> 
                              {permissions?.update && (
                                <Assets
                                  className={classes.writeBox}
                                  src={"/assets/icons/write.svg"}
                                  absolutePath={true}
                                  onClick={() => {
                                    setData(row);
                                    setIsEdit(true);
                                    setModel(true);
                                  }}
                                />
                              )}
                              {permissions?.delete && (
                                <Assets
                                  className={classes.deleteBox}
                                  src={"/assets/icons/delete.svg"}
                                  absolutePath={true}
                                  onClick={() => {
                                    _handleDelete(row?._id);
                                  }}
                                />
                              )}
                            </Box>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    }) :
                      <TableRow>
                        <TableCell colSpan={12}> <DataNotFound icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} />
                        </TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              ) : (
                <WidgetLoader />
              )}
            </TableContainer>
          </Grid>
          {sitePopularityDetails?.count > 0 && <Grid item xs={12}>
            <CustomPagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              count={Math.ceil(sitePopularityDetails?.count / rowsPerPage)}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage} />
          </Grid>
          }
        </Grid>

      </PaperContainer>

      {model && (
        <CommonModal
          open={model}
          onClose={handleClear}
          title={`${isEdit ? "Update" : "Add"} site popularity`}
          content={
            <AddSitePopularity
              data={data}
              setData={setData}
              error={error}
              handleChange={handleChange}
              onSubmit={_addUpdateSitePopularity}
              isEdit={isEdit}
            />
          }
        />
      )}
    </>
  );
};

export default SitePopularity;
